import Axios from 'axios';
import configService from '@/config';

export class BaseApi {
    public api: typeof Axios = Axios;
    public apiPath = '/';
    public baseUrlFor(...args: string[]): string {
        return [configService.config.API_URL, this.apiPath, ...args].join('/');
    }
}
